import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import EditDynamicProfileContainer from 'containers/forms/dynamicProfiles/EditDynamicProfileContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS, DYNAMIC_PROFILE_UPDATE } from 'constants/capabilities';

const EditDynamicProfilePage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/dynamic-profiles">&lt; Dynamic Profiles</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <EditDynamicProfileContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Edit Dynamic Profile', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, DYNAMIC_PROFILE_UPDATE] }),
)(EditDynamicProfilePage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/dynamicProfiles/EditDynamicProfile.js